import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=20b38f6a"
import script from "./ShareButton.vue?vue&type=script&lang=ts"
export * from "./ShareButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports